module.exports = __webpack_public_path__ + "img/prestations.74493223.png";